import { createFileRoute } from '@tanstack/react-router';

import { NavigationBar } from '@/features/settings';
import { toOrganizationId, useSuspenseGetOrganization } from '@/hooks/api';
import { OrganizationProvider } from '@/store';

const OrganizationWrapper = () => {
  const { data: organization } = useSuspenseGetOrganization(toOrganizationId('me'));

  return (
    <OrganizationProvider {...organization}>
      <NavigationBar />
    </OrganizationProvider>
  );
};

export const Route = createFileRoute('/_auth/settings')({
  component: OrganizationWrapper,
});
